import { createSelector, createStructuredSelector } from 'reselect';
import _get from 'lodash/get';
import { commonTranslationSelect, rnSelect, isCNSelect } from '../../index';
import { removeCarDomain, translationsDomain } from '../../domains';

const confirmTransferTranslationsSelect = createSelector(
  translationsDomain,
  ({ removeCar }) => _get(removeCar, 'confirmTransfer') || {}
);

const confirmTransferStatusSelect = createSelector(
  removeCarDomain,
  ({ confirmTransferRequest }) => confirmTransferRequest || {}
);

export default createStructuredSelector({
  confirmTransferTranslations: confirmTransferTranslationsSelect,
  commonTranslations: commonTranslationSelect,
  confirmTransferStatus: confirmTransferStatusSelect,
  rn: rnSelect,
  isCN: isCNSelect,
});
